var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { class: _vm.classList, attrs: { for: _vm.name } },
    [
      _vm._v("\n  " + _vm._s(_vm.label)),
      _vm.required ? _c("sup", { staticClass: "t-tc--danger" }) : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }